import { render, staticRenderFns } from "./salesgroup.vue?vue&type=template&id=57186762"
import script from "./salesgroup.vue?vue&type=script&lang=js"
export * from "./salesgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports